import { AdminPages } from 'src/pages/admin'

const AdminRoutes = [
  {
    path: '/administrator/annonces',
    component: <AdminPages.Annonces />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin']
    }
  },
  {
    path: '/administrator/photos',
    component: <AdminPages.Photos />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin']
    }
  },
  {
    path: '/administrator/photos/:id',
    component: <AdminPages.Photo />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin']
    }
  },
  {
    path: '/administrator/compte/:userId',
    component: <AdminPages.UserAnnonces />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin']
    }
  },
  {
    path: '/administrator/compte',
    component: <AdminPages.Compte />,
    exact: true,
    meta: {
      privateRoute: true,
      roles: ['admin']
    }
  }
]

export default AdminRoutes
